export default "/images/31236a392df4a30593429a65f723ba93.png";